<template>
  <div class="container">
    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>{{ $t("number") }}</th>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("target") }}</th>
          <th>{{ $t("type") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="account in accounts" :key="account.id">
          <td>
            <span v-for="d in account.depth"
              >&NonBreakingSpace;&NonBreakingSpace;&NonBreakingSpace;</span
            >{{ account.number }}
          </td>
          <td>{{ account.name }}</td>
          <td>{{ $t(account.target) }}</td>
          <td>{{ $t(account.type) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tree: [],
      accounts: [],
    };
  },
  computed: {},
  methods: {
    set_tree(tree) {
      let v = this;
      v.tree = tree;

      v.accounts = v.calculate_accounts(tree);
    },
    calculate_accounts(tree) {
      let v = this;
      let accounts = [];

      let calculate = (node, depth) => {
        node.depth = depth;
        accounts.push(node);
        if (node.children) {
          node.children.forEach((child) => {
            calculate(child, depth + 1);
          });
        }
      };

      tree.forEach((node) => {
        calculate(node, 0);
      });

      return accounts;
    },
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}
</style>
